import axios from "axios";
const sendRequest = async ({ url, method }, data = null) => {
  let apiurl = process.env.REACT_APP_BACKEND_URL + "/api" + url;
  let token = localStorage.getItem("auth-token")
    ? localStorage.getItem("auth-token")
    : "";
  try {
    const response = await axios({
      url: apiurl,
      method,
      data,
      headers: {
        AUthorization: `Bearer ` + token,
      },
    });
    return response.data;
  } catch (error) {
    return { error: error.response.data };
  }
};

export { sendRequest };
